export type DiceFace = 1 | 2 | 3 | 4 | 5 | 6;
export type DiceCall = 'OVER' | 'UNDER';

/**
 * A literal six-sided die roll — no relation to any market signal, model, or
 * the app's actual prediction pipeline. `random` is injectable (defaulting
 * to `Math.random`) for determinism in tests, the same convention
 * `predictCoinFlip()` already uses.
 */
export function rollDie(random: () => number = Math.random): DiceFace {
  return (Math.floor(random() * 6) + 1) as DiceFace;
}

/** The split the user asked for: 4, 5, or 6 calls OVER; 1, 2, or 3 calls UNDER. */
export function diceCall(face: DiceFace): DiceCall {
  return face >= 4 ? 'OVER' : 'UNDER';
}
